<template>
  <v-app>
    <dashboard-core-app-bar
      v-model="expandOnHover"
      hide-new-users
    />

    <dashboard-core-drawer
      :items="drawerItems"
      :expand-on-hover.sync="expandOnHover"
    />

    <dashboard-core-view />

    <dashboard-core-settings v-model="expandOnHover" />
  </v-app>
</template>

<script>
  export default {
    name: 'DashboardIndex',

    components: {
      DashboardCoreAppBar: () => import('@/components/core/AppBar'),
      DashboardCoreDrawer: () => import('@/components/core/Drawer'),
      DashboardCoreSettings: () => import('@/components/core/Settings'),
      DashboardCoreView: () => import('@/components/core/View'),
    },

    data: () => ({
      expandOnHover: false,
    }),
    computed: {
      drawerItems: function () {
        if (this.$getUser() && this.$getUser().email === 'prodpak@nordjyske.dk') {
          return [
            {
              icon: 'mdi-weather-sunset',
              title: 'delivery_morning',
              to: '/',

            },
            {
              icon: 'mdi-weather-night',
              title: 'delivery_evening',
              to: '/homerunner/scan',

            },
          ]
        } else {
          return [
            {
              icon: 'mdi-weather-sunset',
              title: 'delivery_morning',
              to: '/',

            },
            {
              group: '/homerunner',
              icon: 'mdi-weather-night',
              title: 'delivery_evening',
              children: [
                {
                  title: 'scan',
                  to: 'scan',
                },
                {
                  title: 'districts',
                  to: 'districts',
                },
                {
                  title: 'out_sorting',
                  to: 'outsorting',
                },
              ],
            }]
        }
      },
    },
  }
</script>
